<script lang="ts">
  import { storyblokEditable } from "@storyblok/svelte";
  import { openLink } from "$lib/consumer/utils/helpers";
  import ArrowButton from "./ArrowButton.svelte";

  // Get the block data
  export let blok;
</script>

<section class="value-props-section section-header-width mx-auto" use:storyblokEditable={blok}>
  <h1 class="value-props-heading type:h2">{blok.heading}</h1>

  <ArrowButton buttonText={blok.buttonText} buttonLink={blok.buttonLink} />

  <div class="value-prop-items">
    {#each blok.valuePropositionItems as item}
      <div
        class="value-prop-item scale-up-on-hover"
        style="background-image: url({item.backgroundImage.filename}/m/740x925)"
        on:click={() => openLink(item.link)}
        on:keydown={(e) => e.key === "Enter" && openLink(item.link)}
        role="button"
        tabindex="0"
      >
        <div class="value-prop-item-content">
          <h3 class="value-prop-item-heading type:h3">{item.heading}</h3>
          <p class="value-prop-item-subheading type:body-medium">{item.subheading}</p>
          <p class="value-prop-item-link type:body-medium">{item.linkText} →</p>
        </div>
      </div>
    {/each}
  </div>
</section>

<style lang="postcss">
  .value-props-section {
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      text-align: center;
    }
  }

  .value-props-heading {
    margin-bottom: 2rem;

    @screen md {
      margin-bottom: 2rem;
    }
  }

  .value-prop-items {
    margin-top: 3rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2rem;

    @screen lg {
      margin-top: 4rem;
    }

    @media (min-width: 1025px) {
      flex-direction: row;
      gap: 3.5rem;
    }
  }

  .value-prop-item {
    height: 70vh;
    max-height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    background-size: cover;
    border-radius: 4px;
    word-break: break-word;

    @media (min-width: 1025px) {
      width: 33%;
      max-height: 550px;
    }
  }

  .value-prop-item-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 2rem;
    border-radius: 4px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
  }

  .value-prop-item-heading,
  .value-prop-item-subheading,
  .value-prop-item-link {
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.7);
  }

  .value-prop-item-heading {
    font-size: 50px;
    color: #fff;
  }

  .value-prop-item-subheading {
    color: #fff;
  }

  .value-prop-item-link {
    margin-top: 1rem;
    font-weight: bold;
    color: #fff;
    text-decoration: none;
  }
</style>
